import RoleDialog from '@/components/Dialog/RoleDialog'
import UserDialog from '@/components/Dialog/UserDialog.vue'
import { Dialog, ValidMsg } from '@/components/tools'
import { t } from '@/locales'
import DataImportEditDialog from './DataImportDialog/DataImportEditDialog'
import RemovableQuoteNoDialog from './DataImportDialog/RemovableQuoteNoDialog'
import DueDateEditDialog from './DueDateEditDialog'

import CustomerReferenceDialog from './NumberDialog/CustomerReferenceDialog'
import EstimateInfoReferenceDialog from './NumberDialog/EstimateInfoReferenceDialog'
import NumberEditCustomerDialog from './NumberDialog/NumberEditCustomerDialog'
import NumberEditProcessingDialog from './NumberDialog/NumberEditProcessingDialog'
import NumberEditSupplierDialog from './NumberDialog/NumberEditSupplierDialog'
import RateReferenceDialog from './NumberDialog/RateReferenceDialog'
import SupplierReferenceDialog from './NumberDialog/SupplierReferenceDialog'

// import DomainDialog from '@/components/Dialog/DomainDialog.vue'
import AcceptEditDialog from './AcceptDialog/AcceptEditDialog.vue'
import AcceptProductsEditDialog from './AcceptDialog/AcceptProductsEditDialog.vue'
import DeliveryExDialog from './AcceptDialog/DeliveryExDialog'
import NumberInfoSelectDialog from './AcceptDialog/NumberInfoSelectDialog'
import ProcessDialog from './AcceptDialog/ProcessDialog'
import ProductCloseSelectDialog from './AcceptDialog/ProductCloseSelectDialog.vue'
import ProductCloseSelectInOrderDialog from './OrderDialog/ProductCloseSelectInOrderDialog.vue'
import AnnualSalesDetailByUserReportDialog from './ReportDialog/annualSalesDetailByUserReportDialog.vue'

import ChangePwdDialog from './ChangePwdDialog'
import CheckReceEditDialog from "./CheckReceInfoDialog/CheckReceEditDialog.vue"
import ReceOrderSelectDialog from './CheckReceInfoDialog/ReceOrderSelectDialog.vue'
import CusPayCloseSelectDialog from './CusPayCloseSelectDialog.vue'
import CustomerEditDialog from './CustomerEditDialog'
import CustomerPayEditDialog from './CustomerPayEditDialog.vue'
import CustomerPayRcvSelectDialog from './CustomerPayRcvSelectDialog.vue'

import UserRolesDialog from '@/components/Dialog/UserRolesDialog.vue'
import AccountOutputDialog from './AccountOutputDialog.vue'
import JpReceDLEditDialog from './JpReceDLEditDialog.vue'
import JpReceDLSelectDialog from './JpReceDLSelectDialog.vue'
import JpReceJPOfficeEditDialog from './JpReceJPOfficeEditDialog.vue'
import JpReceOrderSelectDialog from './JpReceOrderSelectDialog.vue'
import JpReceRequestAgainDialog from './JpReceRequestAgainDialog.vue'
import JpReceSelectDialog from './JpReceSelectDialog.vue'
import ManagerEditDialog from "./ManagerEditDialog.vue"
import InternalProcessCostDialog from './OrderDialog/InternalProcessCostDialog'
import OrderDateSelectDialog from './OrderDialog/OrderDateSelectDialog'
import OrderEditDialog from './OrderDialog/OrderEditDialog.vue'
import OrderExcelOutputDialog from './OrderDialog/OrderExcelOutputDialog'
import OrderProdSelectDialog from './OrderDialog/OrderProdSelectDialog'
import RestockDialog from './OrderDialog/RestockDialog'
import PrepTransEditDialog from './PrepareTransDialog/PrepTransEditDialog.vue'
import PrepTransProdSelectDialog from './PrepareTransDialog/PrepTransProdSelectDialog.vue'
import ProductEditDialog from './ProductEditDialog'
import SendEditDialog from './SendEditDialog.vue'
import SendErrorDialog from './SendErrorDialog.vue'
import SendErrorOutputDialog from './SendErrorOutputDialog.vue'
import SendSelectDialog from './SendSelectDialog.vue'
import SupplierEditDialog from './SupplierEditDialog.vue'
import TransportEditDialog from './TransportEditDialog.vue'
import TransportProdSelectDialog from './TransportProdSelectDialog.vue'
import RequestInfoEditDialog from './requestInfoDialog/RequestInfoEditDialog.vue'
import RequestSuppSelectDialog from './requestInfoDialog/RequestSuppSelectDialog.vue'

import UserCustomerDialog from '@/components/Dialog/UserCustomersDialog.vue'
import ProductQtyChangeDetailDialog from "./AcceptDialog/ProductQtyChangeDetailDialog.vue"
import ProductQtyChangeDialog from "./AcceptDialog/ProductQtyChangeDialog.vue"
import importResultDialog from './CheckReceInfoDialog/importResultDialog.vue'
import AddAllOrderInfoDialog from './OrderDialog//AddAllOrderInfoDialog.vue'
import RequestProductDialog from './requestInfoDialog/RequestProductDialog.vue'

// ADD 2025/08/21 WZC 課題_日本入荷の配送単導入機能の追加 start↓
import JpImportResultDialog from "./JpImportResultDialog.vue"
import MisumiSelectDialog from "./OrderDialog/MisumiSelectDialog.vue"
// ADD 2025/08/21 WZC 課題_日本入荷の配送単導入機能の追加 end↑

function noop() {
  /* Document: Mark as empty with no real business logic */
}

// 共通Dialog：errorList
export function ShowErrorList(messages, ok = noop, cancel = noop) {
  Dialog(
    ValidMsg,
    {
      props: {
        type: 'error',
        messages: messages
      },
      on: {
        ok: ok,
        cancel: cancel
      }
    },
    {
      props: {
        top: '20%',
        customClass: 'check',
        width: '500px'
      }
    }
  )
}

// 共通Dialog：warningList
export function ShowWarningList(messages, ok = noop, cancel = noop) {
  Dialog(
    ValidMsg,
    {
      props: {
        isOkCancel: true,
        type: 'warning',
        messages: messages
      },
      on: {
        ok: ok,
        cancel: cancel
      }
    },
    {
      props: {
        top: '20%',
        customClass: 'check',
        width: '500px'
      }
    }
  )
}

// 注文一覧詳細画面
export function ShowOrderEditDialog(props, title, callback = noop) {
  // eslint-disable-next-line no-undef
  Dialog(
    OrderEditDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        title: title,
        width: t('widgetSize.dialog.detailDialogWidth'),
      }
    }
  )
}

// 一括手配詳細画面
export function ShowAddAllOrderInfoDialog(props, title, callback = noop) {
  // eslint-disable-next-line no-undef
  Dialog(
    AddAllOrderInfoDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        title: title,
        width: t('widgetSize.dialog.detailDialogWidth'),
      }
    }
  )
}

//受注製品選択画面
export function ShowOrderProdSelectDialog(props, title, callback = noop) {
  // eslint-disable-next-line no-undef
  Dialog(
    OrderProdSelectDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        top: t('widgetSize.dialog.DIALOG_TOP'),
        title: title,
        width: t('widgetSize.dialog.detailDialogWidth'),
      }
    }
  )
}

//製品クローズ選択画面
export function ShowProductCloseSelectInOrderDialog(props, title, callback = noop) {
  // eslint-disable-next-line no-undef
  Dialog(
    ProductCloseSelectInOrderDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        top: t('widgetSize.dialog.DIALOG_TOP'),
        title: title,
        width: t('widgetSize.dialog.detailDialogWidth'),
      }
    }
  )
}

//再入荷画面
export function ShowRestockDialog(props, title, callback = noop) {
  // eslint-disable-next-line no-undef
  Dialog(
    RestockDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
         top: t('widgetSize.dialog.DIALOG_TOP'),
        title: title,
        width: t('widgetSize.dialog.detailDialogWidth'),
      }
    }
  )
}

//社内加工原価画面
export function ShowInternalProcessCostDialog(props, title, callback = noop) {
  // eslint-disable-next-line no-undef
  Dialog(
    InternalProcessCostDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        title: title,
        // width: t('widgetSize.ORDER.INTERNAL_DIALOG_WIDTH'),
        width: t('widgetSize.dialog.detailDialogWidth'),
      }
    }
  )
}

//注文書出力詳細画面
export function ShowOrderExcelOutputDialog(props, title, callback = noop) {
  // eslint-disable-next-line no-undef
  Dialog(
    OrderExcelOutputDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        title: title,
        width: "70%",
        customClass: 'orderExcelOutputHeight',
      }
    }
  )
}

// ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
// 手配日選択画面
export function ShowOrderDateSelectDialog(props, title, callback = noop) {
  // eslint-disable-next-line no-undef
  Dialog(
    OrderDateSelectDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        title: title,
        width: '40%',
        customClass: 'specialDialogHeight450',
      }
    }
  )
}
// ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

export function ShowSupplierEditDialog(props, title, callback = noop) {
  // eslint-disable-next-line no-undef
  Dialog(
    SupplierEditDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        title: title,
        width: '60%',
        customClass: 'specialDialogHeight610',
      }
    }
  )
}


// 角色Dialog
export function ShowRoleDialog(props, title, callback = noop) {
  // eslint-disable-next-line no-undef
  Dialog(
    RoleDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        title: title,
        width: '850px'
      }
    }
  )
}

// 用户Dialog
export function ShowUserDialog(props, title, callback = noop) {
  Dialog(
    UserDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        title: title,
        width: '60%',
        customClass: 'specialDialogHeight435',
      }
    }
  )
}
/*
// domainDialog
export function ShowDomainDialog(props, title, callback = noop) {
  Dialog(
    DomainDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        title: title
      }
    }
  )
}
*/

// パスワード変更のダイアログ
export function ShowChangePwdDialog(props, ok = noop, cancel = noop) {
  Dialog(
    ChangePwdDialog,
    {
      props: props,
      on: {
        ok: ok,
        cancel: cancel
      }
    },
    {
      props: {
        title: t('resource.txt.changePassword'),
        customClass: 'specialDialogHeight370',
        width: '500px'
      }
    }
  )
}
/*
// 显示项目工时分部
export function ShowProjectTimeActivityDialog(props, ok = noop, cancel = noop) {
  Dialog(
    ProjectTimeActivityDialog,
    {
      props: props,
      on: {
        ok: ok,
        cancel: cancel
      }
    },
    {
      props: {
        title: t('resource.projectInfo.projectHoursDistribution'),
        width: '800px',
        closeOnClickModal: true
      }
    }
  )
}*/

export function ShowCustomerEditDialog(props, title, callback = noop) {
  // eslint-disable-next-line no-undef
  Dialog(
    CustomerEditDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        title: title,
        width: '60%',
        customClass: 'specialDialogHeight420',
      }
    }
  )
}

export function ShowProductEditDialog(props, title, callback = noop) {
  // eslint-disable-next-line no-undef
  Dialog(
    ProductEditDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        title: title,
        width: '850px',

      }
    }
  )
}

export function ShowNumberEditSupplierDialog(props, title, callback = noop) {
  // eslint-disable-next-line no-undef
  Dialog(
    NumberEditSupplierDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        title: title,
        top: '4%',
        width: t('widgetSize.COMMON_WIDTH.NINETY-FIVE_PERCENT'),
        height:t('widgetSize.ORDER.EXCEL_DIALOG_HEIGHT'),
      }
    }
  )
}

export function ShowNumberEditCustomerDialog(props, title, callback = noop) {
  // eslint-disable-next-line no-undef
  Dialog(
    NumberEditCustomerDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        title: title,
         top: '4%',
        width: t('widgetSize.COMMON_WIDTH.NINETY-FIVE_PERCENT'),
        height:t('widgetSize.ORDER.EXCEL_DIALOG_HEIGHT'),
      }
    }
  )
}
export function ShowNumberEditProcessingDialog(props, title, callback = noop) {
  // eslint-disable-next-line no-undef
  Dialog(
    NumberEditProcessingDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        title: title,
         top: '4%',
        width: t('widgetSize.COMMON_WIDTH.NINETY-FIVE_PERCENT'),
        height:t('widgetSize.ORDER.EXCEL_DIALOG_HEIGHT'),
      }
    }
  )
}

export function ShowCustomerReferenceDialog(props, title, callback = noop) {
  // eslint-disable-next-line no-undef
  Dialog(
    CustomerReferenceDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {

        title: title,
        width: t('widgetSize.COMMON_WIDTH.FORTY_PERCENT'),
        // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 画面と文字サイズの調整
        customClass: 'DialogHeightComm',
        // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      }
    }
  )
}

export function ShowSupplierReferenceDialog(props, title, callback = noop) {
  // eslint-disable-next-line no-undef
  Dialog(
    SupplierReferenceDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        title: title,
        width:t('widgetSize.COMMON_WIDTH.SIXTY_PERCENT'),
      }
    }
  )
}

export function ShowRateReferenceDialog(props, title, callback = noop) {
  // eslint-disable-next-line no-undef
  Dialog(
    RateReferenceDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        title: title,
        customClass: 'specialDialogHeight260',
      }
    }
  )
}

export function ShowEstimateInfoReferenceDialog(props, title, callback = noop) {
  // eslint-disable-next-line no-undef
  Dialog(
    EstimateInfoReferenceDialog,
    {
      props: props,
      on: {
        ok: callback,
      }
    },
    {
      props: {
        title: title,
        customClass: 'specialDialogHeight315',
      }
    }
  )
}

export function ShowManagerEditDialog(props, title, callback = noop) {
  // eslint-disable-next-line no-undef
  Dialog(
    ManagerEditDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        title: title,
        width: '850px',

      }
    }
  )
}

export function ShowCheckReceInfoEditDialog(props, title, callback = noop) {
  // eslint-disable-next-line no-undef
  Dialog(
    CheckReceEditDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        top: t('widgetSize.dialog.DIALOG_TOP'),
        title: title,
        width: t('widgetSize.dialog.detailDialogWidth'),
      }
    }
  )
}

export function ShowReceOrderSelectDialog(props, title, callback = noop) {
  // eslint-disable-next-line no-undef
  Dialog(
    ReceOrderSelectDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        top: t('widgetSize.dialog.DIALOG_TOP'),
        title: title,
        width: t('widgetSize.dialog.detailDialogWidth'),
      }
    }
  )
}

// ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
// 課題_発送予定機能の追加

// 発送予定詳細画面
export function ShowPrepTransEditDialog(props, title, callback = noop) {
  // eslint-disable-next-line no-undef
  Dialog(
    PrepTransEditDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
         title: title,
        top: '0%',
        width: t('widgetSize.COMMON_WIDTH.ONE-HUNDRED_PERCENT'),
        customClass: 'specialDialogHeightALL',
      }

    }
  )
}
// 発送予定製品選択画面
export function ShowPrepTransProdSelectDialog(props, title, callback = noop) {
  // eslint-disable-next-line no-undef
  Dialog(
    PrepTransProdSelectDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
         title: title,
        // UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
        // 未運送製品選択画面と文字サイズの調整
        // top: '0%',
        // width: t('widgetSize.COMMON_WIDTH.ONE-HUNDRED_PERCENT'),
        //customClass: 'specialDialogHeightALL',

        width: t('widgetSize.COMMON_WIDTH.NINETY-FIVE_PERCENT'),
        customClass: 'DialogHeightComm',
        // UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
      }
    }
  )
}
// ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

// 運送一覧詳細画面
export function ShowTransportEditDialog(props, title, callback = noop) {
  // eslint-disable-next-line no-undef
  Dialog(
    TransportEditDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        top: t('widgetSize.dialog.DIALOG_TOP'),
        title: title,
        width: t('widgetSize.dialog.detailDialogWidth'),
      }
    }
  )
}
// 運送一覧詳細画面
export function ShowTransProdSelectDialog(props, title, callback = noop) {
  // eslint-disable-next-line no-undef
  Dialog(
    TransportProdSelectDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        top: t('widgetSize.dialog.DIALOG_TOP'),
        title: title,
        width: t('widgetSize.dialog.detailDialogWidth'),
      }
    }
  )
}
// 受注一覧詳細画面
export function ShowAcceptEditDialog(props, title, callback = noop) {
  // eslint-disable-next-line no-undef
  Dialog(
    AcceptEditDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
     top: t('widgetSize.dialog.DIALOG_TOP'),
        title: title,
        width: t('widgetSize.dialog.detailDialogWidth'),
      }
    }
  )
}
// 受注一覧詳細画面
export function ShowProcessDialog(props, title, callback = noop) {
  // eslint-disable-next-line no-undef
  Dialog(
    ProcessDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        top: '5%',
        title: title,
        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
		// 画面と文字サイズの調整
        // width: t('widgetSize.ACCEPT_ORDER_INFO.DIALOG_ACCEPT_PRODUCT_EDIT_WIDTH'),
        // height:t('widgetSize.ORDER.EXCEL_DIALOG_HEIGHT'),

        width: t('widgetSize.dialog.detailDialogWidth'),
        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      }
    }
  )
}

// 製品クローズ選択画面
export function ShowProductCloseSelectDialog(props, title, callback = noop) {

  // eslint-disable-next-line no-undef
   Dialog(
    ProductCloseSelectDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
         top: t('widgetSize.dialog.DIALOG_TOP'),
        title: title,
        width: t('widgetSize.dialog.detailDialogWidth'),
      }
    }
  )
}

// 製品数変更
export function ShowProductQtyChangeDialog(props, title, callback = noop) {

  // eslint-disable-next-line no-undef
   Dialog(
    ProductQtyChangeDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
         top: t('widgetSize.dialog.DIALOG_TOP'),
        title: title,
        width: t('widgetSize.dialog.detailDialogWidth'),
      }
    }
  )
}
// 製品数変更詳細画面
export function ShowProductQtyChangeDetailDialog(props, title, callback = noop) {

  // eslint-disable-next-line no-undef
   Dialog(
    ProductQtyChangeDetailDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
         top: t('widgetSize.dialog.DIALOG_TOP'),
        title: title,
        width: t('widgetSize.dialog.detailDialogWidth'),
      }
    }
  )
}




// 納品異常画面
export function ShowDeliveryExDialog(props, title, callback = noop) {
  // eslint-disable-next-line no-undef
   Dialog(
    DeliveryExDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        top: t('widgetSize.dialog.DIALOG_TOP'),
        title: title,
        width: t('widgetSize.dialog.detailDialogWidth'),
      }
    }
  )
}



// 採番一覧選択画面
export function ShowNumberInfoDialog(props, title, callback = noop) {
  // eslint-disable-next-line no-undef
  Dialog(
    NumberInfoSelectDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        top: t('widgetSize.dialog.DIALOG_TOP'),
        title: title,
        width: t('widgetSize.dialog.detailDialogWidth'),
        // height: '400px'
      }
    }
  )
}

// 受注製品編集画面の表示
export function ShowAcceptProductsDialog(props, title, callback = noop) {
  // eslint-disable-next-line no-undef
  Dialog(
    AcceptProductsEditDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        top: t('widgetSize.dialog.DIALOG_TOP'),
        title: title,
        width: t('widgetSize.dialog.detailDialogWidth'),
        // height: '400px'
      }
    }
  )
}


// 支払一覧詳細画面
export function ShowCustomerPayEditDialog(props, title, callback = noop) {
  // eslint-disable-next-line no-undef
  Dialog(
    CustomerPayEditDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        top: t('widgetSize.dialog.DIALOG_TOP'),
        title: title,
        width: t('widgetSize.dialog.detailDialogWidth'),
      }
    }
  )
}
// 支払入荷選択画面
export function ShowCustomerPayRcvSelectDialog(props, title, callback = noop) {
  // eslint-disable-next-line no-undef
  Dialog(
    CustomerPayRcvSelectDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        top: t('widgetSize.dialog.DIALOG_TOP'),
        title: title,
       width: t('widgetSize.dialog.detailDialogWidth'),
      }
    }
  )
}
// クローズデータ選択画面
export function ShowCusPayCloseSelectDialog(props, title, callback = noop) {
  // eslint-disable-next-line no-undef
  Dialog(
    CusPayCloseSelectDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        top: t('widgetSize.dialog.DIALOG_TOP'),
        title: title,
       width: t('widgetSize.dialog.detailDialogWidth'),
      }
    }
  )
}

// 日本入荷種類選択画面
export function ShowJpReceSelectDialog(props, title, callback = noop) {
  // eslint-disable-next-line no-undef
  Dialog(
    JpReceSelectDialog,
    {
      props: props,
      on: {
        // ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        title: title,
        customClass: 'specialDialogHeight150',
      }
    }
  )
}
// 日本入荷詳細画面（大連工場）
export function ShowJpReceDLEditDialog(props, title, callback = noop) {
  Dialog(
    JpReceDLEditDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback,
      }
    },
    {
      props: {
        top: t('widgetSize.dialog.DIALOG_TOP'),
        title: title,
        width: t('widgetSize.dialog.detailDialogWidth'),
      }
    }
  )
}
// 運送台帳選択画面（大連工場）
export function ShowJpReceDLSelectDialog(props, title, callback = noop) {
  Dialog(
    JpReceDLSelectDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        top: t('widgetSize.dialog.DIALOG_TOP'),
        title: title,
        width: t('widgetSize.dialog.detailDialogWidth'),
      }
    }
  )
}
// 日本入荷詳細画面（大連以外の工場）
export function ShowJpReceJPOfficeEditDialog(props, title, callback = noop) {
  Dialog(
    JpReceJPOfficeEditDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        top: t('widgetSize.dialog.DIALOG_TOP'),
        title: title,
       width: t('widgetSize.dialog.detailDialogWidth'),
      }
    }
  )
}
// 日本入荷：注文製品選択画面
export function ShowJpReceOrderSelectDialog(props, title, callback = noop) {
  Dialog(
    JpReceOrderSelectDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        top: t('widgetSize.dialog.DIALOG_TOP'),
        title: title,
       width: t('widgetSize.dialog.detailDialogWidth'),
      }
    }
  )
}
// 再入荷申請確認画面
export function ShowJpReceRequestAgainDialog(props, title, callback = noop) {
  Dialog(
    JpReceRequestAgainDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        top: t('widgetSize.dialog.DIALOG_TOP'),
        title: title,
        width: t('widgetSize.dialog.detailDialogWidth'),
      }
    }
  )
}
// 出荷詳細画面
export function ShowSendEditDialog(props, title, callback = noop) {
  Dialog(
    SendEditDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        top: t('widgetSize.dialog.DIALOG_TOP'),
        title: title,
        width: t('widgetSize.dialog.detailDialogWidth'),
      }
    }
  )
}
// 出荷製品選択画面
export function ShowSendSelectDialog(props, title, callback = noop) {
  Dialog(
    SendSelectDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        top: t('widgetSize.dialog.DIALOG_TOP'),
        title: title,
        width: t('widgetSize.dialog.detailDialogWidth'),
      }
    }
  )
}
// 納品異常処理画面
export function ShowSendErrorDialog(props, title, callback = noop) {
  Dialog(
    SendErrorDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        top: t('widgetSize.dialog.DIALOG_TOP'),
        title: title,
        width: t('widgetSize.dialog.detailDialogWidth'),
      }
    }
  )
}
// 赤伝票出力確認画面
export function ShowSendErrorOutputDialog(props, title, callback = noop) {
  Dialog(
    SendErrorOutputDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        top: t('widgetSize.dialog.DIALOG_TOP'),
        title: title,
        width: t('widgetSize.dialog.detailDialogWidth'),
      }
    }
  )
}

//ユーザ管理の担当得意先の設定
export function ShowUserCustomerDialog(props, title) {
  Dialog(
    UserCustomerDialog,
    {
      props: props
    },
    {
      props: {
        title: title,
        customClass: 'specialDialogHeight580',
        // UPD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓
        // width: '900px'
        width: '70%',
        // UPD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑
      }
    }
  )
}

//ユーザ管理の権限の設定
export function ShowUserRoleDialog(props, title) {
  Dialog(
    UserRolesDialog,
    {
      props: props
    },
    {
      props: {
        title: title,
        customClass: 'specialDialogHeight580',
        width: '900px'
      }
    }
  )
}



//請求詳細ダイアログ
export function ShowRequestInfoDialog(props, title, callback = noop) {
  Dialog(
    RequestInfoEditDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        title: title,
        width: t('widgetSize.dialog.detailDialogWidth'),
      }
    }
  )
}

//勘定書出力ダイアログ
export function ShowAccountOutputDialog(props, title, callback = noop) {
  Dialog(
    AccountOutputDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
       props: {
        title: title,
        customClass: 'specialDialogHeight260',
      }
    }
  )
}

// 請求製品選択
export function ShowReqProductDialog(props, title, callback = noop) {
  Dialog(
    RequestProductDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        title: title,
        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 画面と文字サイズの調整
        // width: '95%',
        width: t('widgetSize.dialog.detailDialogWidth'),
        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      }
    }
  )
}
// ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
//請求補足データ選択画面
export function ShowRequestSuppSelectDialog(props, title, callback = noop) {
  Dialog(
    RequestSuppSelectDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        title: title,
        width: t('widgetSize.dialog.detailDialogWidth'),
      }
    }
  )
}
// ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

export function ShowImportResultDialog(props, title, callback = noop) {
  Dialog(
    importResultDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        top: t('widgetSize.dialog.DIALOG_TOP'),
        title: title,
        width: t('widgetSize.dialog.detailDialogWidth'),
      }
    }
  )
}

// 個人売上詳細画面
export function ShowAnnualSalesDetailByUserReportDialog(props, title, callback = noop) {
  // eslint-disable-next-line no-undef
  Dialog(
    AnnualSalesDetailByUserReportDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        title: title,
        width: t('widgetSize.dialog.detailDialogWidth'),
      }
    }
  )
}

//受注データ取込詳細画面
export function ShowDataImportEditDialog(props, title, callback = noop) {
  Dialog(
    DataImportEditDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        title: title,
        // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓
        // top: '4%',
        // width: t('widgetSize.COMMON_WIDTH.NINETY-FIVE_PERCENT'),
        // height:t('widgetSize.ORDER.EXCEL_DIALOG_HEIGHT'),
        top: '0%',
        width: t('widgetSize.COMMON_WIDTH.ONE-HUNDRED_PERCENT'),
        customClass: 'specialDialogHeightALL',
        // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑


      }
    }
  )
}

//受注データ取込：削除見積選択画面
export function ShowRemovableQuoteNoDialog(props, title, callback = noop) {
  Dialog(
    RemovableQuoteNoDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        title: title,
        top: '4%',
        width: t('widgetSize.COMMON_WIDTH.FORTY_PERCENT'),
        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 画面と文字サイズの調整
        customClass: 'DialogHeightComm',
        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      }
    }
  )
}

// ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
// 課題_納期分割機能の追加
// 納品分割、製品補足、製品クローズ、入荷異常作成、納品異常作成
export function ShowDueDateEditDialog(props, title, callback = noop) {
  Dialog(
    DueDateEditDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        title: title,
        top: '4%',
        width: '95%',
        customClass: 'DialogHeightComm',
      }
    }
  )
}

// ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

// ADD 2025/08/21 WZC 課題_日本入荷の配送単導入機能の追加 start↓
//　ミスミ仕入先の場合、配送単出力選択画面（ミスミ大連：大連検査室入荷用　ミスミ大連以外：日本入荷用）
export function ShowMisumiSelectDialog(props, title, callback = noop) {
  // eslint-disable-next-line no-undef
  Dialog(
    MisumiSelectDialog,
    {
      props: props,
      on: {
        // ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        title: title,
        customClass: 'specialDialogHeight150',
      }
    }
  )
}

//配送単導入詳細情報画面
export function ShowJpImportResultDialog(props, title, callback = noop) {
  Dialog(
    JpImportResultDialog,
    {
      props: props,
      on: {
        ok: callback,
        cancel: callback
      }
    },
    {
      props: {
        top: t('widgetSize.dialog.DIALOG_TOP'),
        title: title,
        width: t('widgetSize.dialog.detailDialogWidth'),
      }
    }
  )
}
// ADD 2025/08/21 WZC 課題_日本入荷の配送単導入機能の追加 end↑

